import { Link } from '@mui/material';
import { memo, type ReactNode } from 'react';
import { useServiceDeskLink } from '@/components/Common/SupportLink/createServiceDeskLink';

export const ErrorFallbackSupportLink = memo(function ErrorFallbackSupportLink({ children }: { children: ReactNode }) {
  const url = useServiceDeskLink({
    summary: 'I need help with ...',
    description: 'Describe in detail what you need help with',
  });

  return (
    <Link href={url} rel="noreferrer" target="_blank" underline="always" color="textPrimary">
      {children}
    </Link>
  );
});
